import ca from "element-ui/src/locale/lang/ca";

class FileTool {
    base64ToDownloadData (base64Data) {
        const badstr = atob(base64Data);
        let n = badstr.length;
        const u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = badstr.charCodeAt(n);
        }
        return u8arr
    }
    saveFile (data, fileName, callback) {
        const blob = new Blob([data]);//,{type: 'application/vnd.ms-excel;charset=utf-8'}

        const elink = document.createElement('a');

        elink.download = decodeURI(fileName);

        elink.style.display = 'none';

        elink.href = URL.createObjectURL(blob);

        document.body.appendChild(elink);

        elink.click();

        URL.revokeObjectURL(elink.href); // 释放URL 对象

        document.body.removeChild(elink);
        if (callback){
            callback()
        }

    }
}

export default FileTool